'use client';
import { isArray, isString } from '@s7/utils';

const getMs = (time)=>isArray(time) ? time.join(', ') : isString(time) ? time : `${time}ms`;
const transition = (theme)=>(options)=>{
        const { props = [
            'all'
        ], fn = theme.timingFunction, delay = 0, duration = 200 } = options || {};
        return {
            transitionTimingFunction: isArray(fn) ? fn.join(', ') : fn,
            transitionProperty: isArray(props) ? props.join(', ') : props,
            transitionDelay: isArray(delay) ? delay.map(getMs).join(', ') : getMs(delay),
            transitionDuration: isArray(duration) ? duration.map(getMs).join(', ') : getMs(duration)
        };
    };

export { transition };
//# sourceMappingURL=transition.js.map
